import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { authTokenSelector } from 'redux/auth/selectors';
import { getCurrentEvent } from 'redux/events/selectors';
import { pushGlobalEvent } from 'redux/events/actions';
import EventsPanel from './EventsPanel';

const mapStateToProps = (state: any) => ({
  authToken: authTokenSelector(state),
  currentEvent: getCurrentEvent(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  pushGlobalEvent: (event: any, token: string) => dispatch(pushGlobalEvent(event, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsPanel)
